import { render, staticRenderFns } from "./GeneralReports.vue?vue&type=template&id=4015f5a6"
import script from "./GeneralReports.vue?vue&type=script&lang=ts"
export * from "./GeneralReports.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports